module.exports = __webpack_public_path__ + "static/media/gallery_2_1.ae920a07.jpg";